import * as specialtyCodes from "./specialtyCodes";

export const DEFAULT_SPECIALTY = specialtyCodes.PRIMARY_CARE;

export {
  specialtyCodes,
};
